import {  Component, Input } from '@angular/core';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent  {
  projects = [
    {
      solutionTitle: 'الهيئة العامة للاستثمار والمناطقالحرة تستضيف مؤتمر لتوعية م...',
      solutionDesc: ' ستضافت الهيئة العامة للاستثمار والمناطق الحرة مؤتمر خاص بشرح آلية تعديل حدودستضافت الهيئة العامة للاستثمار والمناطق الحرة مؤتمر خاص بشرح آلية تعديل حدود',
      solutionLink: '',
      solutionImage: '../../../assets/TEST1.png',
      date:'9 سبتمبر 2025'
    },
    {
      solutionTitle: 'الهيئة العامة للاستثمار والمناطقالحرة تستضيف مؤتمر لتوعية م...',
      solutionDesc: ' ستضافت الهيئة العامة للاستثمار والمناطق الحرة مؤتمر خاص بشرح آلية تعديل حدودستضافت الهيئة العامة للاستثمار والمناطق الحرة مؤتمر خاص بشرح آلية تعديل حدود',
      solutionLink: '',
      solutionImage: '../../../assets/TEST1.png',
      date:'9 سبتمبر 2025'
    },
    {
      solutionTitle: 'الهيئة العامة للاستثمار والمناطقالحرة تستضيف مؤتمر لتوعية م...',
      solutionDesc: ' ستضافت الهيئة العامة للاستثمار والمناطق الحرة مؤتمر خاص بشرح آلية تعديل حدودستضافت الهيئة العامة للاستثمار والمناطق الحرة مؤتمر خاص بشرح آلية تعديل حدود',
      solutionLink: '',
      solutionImage: '../../../assets/TEST1.png',
      date:'9 سبتمبر 2025'
    },
    {
      solutionTitle: 'الهيئة العامة للاستثمار والمناطقالحرة تستضيف مؤتمر لتوعية م...',
      solutionDesc: ' ستضافت الهيئة العامة للاستثمار والمناطق الحرة مؤتمر خاص بشرح آلية تعديل حدودستضافت الهيئة العامة للاستثمار والمناطق الحرة مؤتمر خاص بشرح آلية تعديل حدود',
      solutionLink: '',
      solutionImage: '../../../assets/TEST1.png',
      date:'9 سبتمبر 2025'
    },
    {
      solutionTitle: 'الهيئة العامة للاستثمار والمناطقالحرة تستضيف مؤتمر لتوعية م...',
      solutionDesc: ' ستضافت الهيئة العامة للاستثمار والمناطق الحرة مؤتمر خاص بشرح آلية تعديل حدودستضافت الهيئة العامة للاستثمار والمناطق الحرة مؤتمر خاص بشرح آلية تعديل حدود',
      solutionLink: '',
      solutionImage: '../../../assets/TEST1.png',
      date:'9 سبتمبر 2025'
    }
  ];

  @Input() title: string = '';

  sliderConfig: any = {};

  constructor() {
    this.sliderConfig = {
      accessibility: true,
      rtl: true,
      dots: false,
      arrows: true,
      prevArrow:
        '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><img src="../../../assets/Iconarrowl.png"></button>',
      nextArrow:
        '<button class="slick-next slick-arrow" aria-label="Next" type="button"><img src="../../../assets/IconARROW.png"></button>',

      autoplay: false,
      swipe: false,
      initialSlide: 0,
      speed: 800,
      infinite: true,
      pauseOnHover: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      variableWidth: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            centerPadding: '0%',
            dots: true,
            centerMode: false,
          },
        },
      ],
    };
  }

}
